import { useTranslations } from '@vocab/react';
import { Stack, Text, Toggle } from 'braid-design-system';

import { PageTitles } from 'src/components/Notifications/pageTitle';
import { useAnalytics } from 'src/contexts/AnalyticsContext';
import {
  useGetApproachability,
  useGetProfileVisibility2,
  useUpdateApproachability,
} from 'src/modules/graphql/visibility/data';
import { useTypedSelector } from 'src/reducers';

import translations from './.vocab';

export const EditApproachabilitySettings = () => {
  const { t } = useTranslations(translations);
  const brand = useTypedSelector((state) => state.page.pageAnalytics.brand);

  const {
    approachable,
    loading: approachableLoading,
    error: approachableError,
  } = useGetApproachability();

  const { updateApproachability } = useUpdateApproachability();

  const { trackApproachabilityUpdated } = useAnalytics();

  const onChangeFn = (approachableInput: boolean) => {
    updateApproachability({
      variables: { input: { approachable: approachableInput } },
    });

    trackApproachabilityUpdated({ approachable: approachableInput });
  };

  const { profileVisibility2, loading: profileVisibility2Loading } =
    useGetProfileVisibility2();

  const showApproachabilitySettings =
    profileVisibility2?.__typename === 'PublicVisibilityOption' ||
    profileVisibility2?.__typename === 'StandardVisibilityOption' ||
    profileVisibility2?.__typename === 'LimitedVisibilityOption';

  return showApproachabilitySettings &&
    !profileVisibility2Loading &&
    !approachableLoading &&
    !approachableError ? (
    <Stack space="medium">
      <Text weight="strong">{t('Approachability')}</Text>
      <Text tone="secondary">
        {t(
          'Employers looking at a list of suitable profiles will see a label...',
          {
            brand: PageTitles[brand],
          },
        )}
      </Text>
      <Toggle
        id="approachabilityToggle"
        data={{ automation: 'approachability-toggle' }}
        label={t('Show my approachability')}
        on={approachable}
        onChange={onChangeFn}
        align="justify"
      />
    </Stack>
  ) : null;
};
